export enum UserOwnershipKind {
    Offer = 'Offer',
    Assignation = 'Assignation',
    Qualification = 'Qualification'
}